/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import nbrApi from '../../services/nbrApi'
import '../../css/accepted_task.css'
import { useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'

function AcceptedTask() {
    const [data, setData] = useState([])
    let userData = JSON.parse(localStorage?.getItem('userDetails')) || []
    let loginData = localStorage?.getItem('selectedLoginData') ? JSON.parse(localStorage?.getItem('selectedLoginData')) : null
    let property_data = userData?.filter(e => parseInt(e?.properties_id) === parseInt(loginData?.properties_id)
        && parseInt(e?.roles_id) === parseInt(loginData?.role_id))?.[0] || {}
    const [taskType, setTaskType] = useState('')
    const [taskTitle, setTask] = useState('')
    const [changedTaskData, setChangedTaskData] = useState({})
    const [startBtnStatus, setStartBtnStatus] = useState(false)

    const [clearRoomValue, setClearRoomValue] = useState('')
    const [hkreq, setHkreq] = useState('')
    const [taskStatus, setTaskStatus] = useState('')
    const [trackingLevel, setTrackingLevel] = useState('')
    const [segmentValue, setSegment] = useState('')
    const [processValue, setProcess] = useState('')
    const [taskGroup, setTaskGroup] = useState('')
    // const [task_status_name, setTaskGroup] = useState('')
    let isRequestPending = false
    let older_task = null
    // let latest_task = null
    // let taskGroupHide = (changedTaskData?.hktgsm_id || changedTaskData?.hktpsm_id || changedTaskData?.hkwssm_id) ? true : false
    // let taskProcessHide = changedTaskData?.hktpsm_id ? true : false
    const { id } = useParams();
    const navigate = useNavigate()
    let accepted_task_data = {}
    let btnCompletedText = 'Start Task'
    let btnColor = 'success'

    if ((changedTaskData?.room_item_task_status === 'in process' || changedTaskData?.task_group_status === 'in process' || changedTaskData?.work_segment_status === 'in process' || changedTaskData?.task_process_status === 'in process')) {
        btnCompletedText = 'Finished This'
        btnColor = 'danger'
    } else {
        btnCompletedText = changedTaskData?.hktgsm_id ? 'Start' : 'Start Task'
        btnColor = 'success'
    }

    // get data
    const getData = async () => {
        // if property data exist
        // console.log(property_data)
        if (property_data) {
            try {
                const responseRequestsData = await nbrApi.get(`/gethkrequestsaccepted?p_id=${property_data?.properties_id}&re_id=${property_data?.resources_id}`)
                let responseRequests = responseRequestsData?.data || []
                if (responseRequests?.length === 0) {
                    // Show a toast message and return early
                    showToast('Request Completed');
                    return;
                }
                if (responseRequests?.length > 0) {
                    setData(responseRequests)
                    accepted_task_data = responseRequests?.[0] || {}
                } else {
                    setData([])
                }
            } catch {
                setData([])
            }

            //  initial list 
            if (accepted_task_data?.tracking_level === 'task group') {
                setTaskType('hktgsm_id')
            } else if (accepted_task_data?.tracking_level === 'room item task') {
                setTaskType('hktsm_id')
            } else if (accepted_task_data?.tracking_level === 'work segment') {
                setTaskType('hkwssm_id')
            } else if (accepted_task_data?.tracking_level === 'task process') {
                setTaskType('hktpsm_id')
            } else {
                setTaskType('hktsm_id')
            }
        }
    }
    // show alert
    function showToast(message) {
        Swal.fire({
            position: 'center',
            icon: 'success', // You can change the icon
            title: message,
            showConfirmButton: false,
            timer: 2000
        }).then(() => {
            navigate('/housekeeping-request')
        });
    }

    // change => taskType
    useEffect(() => {
        const getData = async () => {
            isRequestPending = true
            if (taskType) {
                const taskResponse = await nbrApi.get(`/starttracking.html?hkrq_id=${data[0]?.hkrq_id}&sm_action=list&${taskType}=-1`);
                setChangedTaskData(taskResponse?.data?.[0] || {})
                // Check if hkrq_id is undefined or null
                if (taskResponse?.data?.length === 0) {
                    // Show a toast message and return early
                    showToast('Request Completed');
                    return;
                }
                // console.log(taskResponse?.data)
                let latest_task = taskResponse?.data?.[0] || {}

                if (latest_task) {
                    // console.log(latest_task)
                    setTrackingLevel(latest_task?.tracking_level || accepted_task_data?.tracking_level || null)
                    setSegment(latest_task?.segment_name || null)
                    setProcess(latest_task?.process_name || null)
                    setTaskGroup(latest_task?.hkwssm_id ? 'Work Segment' : latest_task?.hktpsm_id ? latest_task?.segment_name : latest_task?.hktgsm_id ? latest_task?.process_name : latest_task?.task_group_name || null)
                    setTask(latest_task?.hkwssm_id ? latest_task?.segment_name : latest_task?.hktpsm_id ? latest_task?.process_name : latest_task?.hktgsm_id ? latest_task?.task_group_name : latest_task?.task_name || null)
                    setTaskStatus(latest_task?.hktpsm_id ? latest_task?.task_process_status : latest_task?.hkwssm_id ? latest_task?.work_segment_status : latest_task?.hktgsm_id ? latest_task?.task_group_status : latest_task?.room_item_task_status || "Approved")
                    isRequestPending = false
                    setStartBtnStatus(false)
                    setClearRoomValue(latest_task?.room_number);
                    setHkreq(latest_task?.hkrq_id ? latest_task?.hkrq_id : accepted_task_data?.hkrq_id)
                }
                // getData()
            }
        }

        getData()

    }, [taskType])

    // init
    useEffect(() => {
        getData()
    }, [])
    // console.log(latest_task)

    // handleStartAction
    const handleStartAction = async () => {
        isRequestPending = true
        console.log(changedTaskData, taskType)
        let smValue = changedTaskData?.hktpsm_id ?
            changedTaskData ? changedTaskData?.task_process_status === 'accepted' ? 'start' : 'complete' : 'list' :
            changedTaskData?.hkwssm_id ?
                changedTaskData ? changedTaskData?.work_segment_status === 'accepted' ? 'start' : 'complete' : 'list' :
                changedTaskData?.hktgsm_id ?
                    changedTaskData ? changedTaskData?.task_group_status === 'accepted' ? 'start' : 'complete' : 'list' :
                    changedTaskData ? changedTaskData?.room_item_task_status === 'accepted' ? 'start' : 'complete' : 'list'

        const taskResponse = await nbrApi.get(`/starttracking.html?hkrq_id=${hkreq}&sm_action=${smValue}&${taskType}=${changedTaskData ? changedTaskData[taskType] : -1}`)
        older_task = changedTaskData
        let latest_task = taskResponse?.data?.[0] || {}
        if (latest_task) {
            // console.log(latest_task)
            setTrackingLevel(latest_task?.tracking_level || accepted_task_data?.tracking_level || null)
            setSegment(latest_task?.segment_name || null)
            setProcess(latest_task?.process_name || null)
            setTaskGroup(latest_task?.hkwssm_id ? 'Work Segment' : latest_task?.hktpsm_id ? latest_task?.segment_name : latest_task?.hktgsm_id ? latest_task?.process_name : latest_task?.task_group_name || null)
            setTask(latest_task?.hkwssm_id ? latest_task?.segment_name : latest_task?.hktpsm_id ? latest_task?.process_name : latest_task?.hktgsm_id ? latest_task?.task_group_name : latest_task?.task_name || null)
            setTaskStatus(latest_task?.hktpsm_id ? latest_task?.task_process_status : latest_task?.hkwssm_id ? latest_task?.work_segment_status : latest_task?.hktgsm_id ? latest_task?.task_group_status : latest_task?.room_item_task_status || "Approved")
            isRequestPending = false
            setStartBtnStatus(false)
            setClearRoomValue(latest_task?.room_number);
            setHkreq(latest_task?.hkrq_id ? latest_task?.hkrq_id : accepted_task_data?.hkrq_id)
        }
        setChangedTaskData(taskResponse?.data?.[0] || {})
        getData();
        isRequestPending = false
    }

    // render details 
    const RenderDetailsView = ({ data }) => {
        return (
            <>
                <div className='borderContainer mb-3'>
                    {/* Title */}
                    <h5 className='bg-primary text-white p-2 text-center mb-0'>
                        Housekeeping Request #{id}
                    </h5>

                    {/* request_summary */}
                    <h5 className='bg-white text-secondary p-2 text-center mb-0 text-capitalize fs-4'>
                        {data?.request_summary ? data?.request_summary : ''}
                    </h5>
                </div>
                <div className='borderContainer mb-3'>
                    <h5 className='bg-warning text-white p-2 text-center mb-0'>
                        Request Details
                    </h5>
                    <h5 className='bg-white text-secondary p-2 text-center mb-0 text-capitalize fs-4'>
                        <ul className='list-group list-group-flush'>
                            {segmentValue && <li className='list-group-item-ct d-flex justify-content-between align-items-center'>
                                <p className="mb-0 fs-15 text-primary font-w600">Stage</p>
                                <span class="ms-auto fs-15 mb-0  text-black font-w600">{segmentValue}</span>
                            </li>}
                            {processValue && <li className='list-group-item-ct d-flex justify-content-between align-items-center'>
                                <p className="mb-0 fs-15 text-primary font-w600">Process</p>
                                <span class="ms-auto fs-15 mb-0  text-black font-w600">{processValue}</span>
                            </li>}
                            <li className='list-group-item-ct d-flex justify-content-between align-items-center border-0'>
                                <p className="mb-0 fs-15 text-primary font-w600">Tracking Level</p>
                                <span class="ms-auto fs-15 mb-0  text-black font-w600">{trackingLevel}</span>
                            </li>
                        </ul>
                    </h5>
                </div>

                <div className='borderContainer mb-3'>
                    <h5 className='bg-primary text-white p-2 text-center mb-0'>
                        {trackingLevel || null}
                    </h5>
                    <h5 className='bg-white text-secondary p-2 text-center mb-0 text-capitalize fs-4'>
                        <ul className='list-group list-group-flush'>
                            <li className='list-group-item-ct d-flex justify-content-between align-items-center border-0'>
                                <p className="mb-0 fs-8 text-danger font-w600">{segmentValue}</p>
                                <span class="badge badge-success text-sm badge-xs">{taskStatus}</span>
                            </li>
                        </ul>
                    </h5>
                </div>

                <div className='d-flex justify-content-center'>
                    <button disabled={isRequestPending} type='button' onClick={handleStartAction} className={`btn btn-sm btn-${btnColor}`}>{btnCompletedText}</button>
                </div>
            </>
        )
    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Task Status</h4>
                        <h4 className="heading me-2">#{id}</h4>
                    </div>

                    <div className="card-body d-lg-flex justify-content-center">
                        {data?.length === 0 &&
                            <p className='alert alert-primary fw-bold'>No Data available !</p>}
                        {
                            data?.length > 0 &&
                            <div className='col-lg-5'>
                                <RenderDetailsView data={data[0]} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcceptedTask